module.exports = __webpack_public_path__ + "media/images/pc/banner/mitsubachi-a20c244382cd4929c3b2826593c67c04.png";